module.exports = __webpack_public_path__ + "assets/media/importemptystate.66182186.svg";